import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import EntryScreen from '../../components/EntryScreen';

// El login sigue siendo una ruta (es la pantalla de "/" y de "/login", y las
// demás pantallas redirigen acá si no hay sesión), pero el formulario ya no se
// dibuja a mano: lo pone la pantalla de entrada compartida, la misma de todas
// las apps del hub. EntryScreen.jsx es copia de shared/vls-ui/ y NO se edita
// acá: se cambia en shared/ y se reparte con scripts/sync-ui.sh.
//
// OJO, a diferencia de las otras apps del hub, acá NO hay estado de "sin
// acceso", y es a propósito: esta app no tiene gate por rol. Cualquiera con
// sesión entra, los datos los protege la RLS de vlsdb, y `userRole` solo se usa
// para la etiqueta del encabezado (ver NavigationHeader.jsx). Agregarle un gate
// dejaría afuera a gente que hoy entra, que es un cambio de comportamiento y no
// parte de unificar la pantalla de entrada. Por eso el contexto expone
// `rolError` pero acá no se consume.
const MODULO = 'Visitas de Mercadeo';
const RUTA_POST_LOGIN = '/visit-form-registration-screen';

export default function LoginScreen() {
  const { signIn, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  // SSO: si ya hay sesión (la cookie .vlscr.net del hub), saltar adentro sin
  // pedir nada. Es también el camino de vuelta después de un ingreso correcto:
  // EntryScreen llama signIn, cambia el estado de auth, y este efecto navega.
  useEffect(() => {
    if (!loading && isAuthenticated) navigate(RUTA_POST_LOGIN, { replace: true });
  }, [loading, isAuthenticated, navigate]);

  if (loading) return <EntryScreen modulo={MODULO} estado="cargando" />;
  return <EntryScreen modulo={MODULO} estado="login" onSignIn={signIn} />;
}
